import React from "react"
import Icon from "components/elements/Icon"
import Button from "components/Buttons/Button"
import WebsiteLink from "components/elements/WebsiteLink"
import { Box, Flex, Text } from "@chakra-ui/react"
import { Website } from "sharedTypes"
import Popover from "../../../dialogs/Popover"

interface Props {
  website: Website
}

const WebsiteStatusIndicator = ({ website }: Props) => {
  if (!website) {
    return null
  }

  const { url, published, previewUrl } = website

  let iconColor = "gray.300"
  if (published) {
    iconColor = "green.300"
  } else if (url) {
    iconColor = "orange.300"
  }

  return (
    <Box
      pos="absolute"
      zIndex={10}
      h={5}
      mr={6}
      mt={2}
      right={0}
      top={0}
      bottom={0}
    >
      {url && (
      <Popover
        trigger={(
          <Icon
            color={iconColor}
            size={3.5}
            icon="dot"
            cursor={!url ? "pointer" : ""}
          />
        )}
        placement="right"
        triggerEvent="hover"
        body={(
          <Flex direction="column" gap={8} px={4} py={3} textAlign="left" minW="200px">
            <Flex direction="column" gap={1}>
              <Text fontWeight="bold">Status</Text>
              <Flex align="center" justify="space-between">
                <Flex align="center" gap={2}>
                  <Icon color={iconColor} size={3.5} icon="dot" />
                  <Text as="span">{published ? "Published" : "Draft"}</Text>
                </Flex>
                {!published && (
                <Button
                  size="xs"
                  variant="outline"
                  colorScheme="blue"
                  ml={3}
                  leftIcon="link-external"
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault()
                    e.stopPropagation()
                    window.open(previewUrl)
                  }}
                >
                  Preview
                </Button>
                )}
              </Flex>
            </Flex>
            {published && (
            <Flex direction="column" gap={1}>
              <Text fontWeight="bold">URL</Text>
              <WebsiteLink website={website} />
            </Flex>
            )}
          </Flex>
        )}
        contentWidth="auto"
      />
      )}
    </Box>
  )
}

export default WebsiteStatusIndicator
